<template lang="">
  <div class="app-create-new-ai-content__section--review-details app-create-new-ai-content__section">
    <div class="app-create-new-ai-content__section-header">
      <h4 class="app-create-new-ai-content__section-title">Final details</h4>
      <p class="app-create-new-ai-content__section-instructions">Look over the final details before generating your course</p>
    </div>
    <div>
      <div class="app-create-new-ai-content__section-body grid">
        <div class="col-12">
          <div class="input text">
            <label for="name">Title</label>
            <input type="text" class="form-control" name="name" id="name" v-model="publication.name" disabled>
          </div>
        </div>
        <div class="col-12">
          <div class="input text">
            <label for="name">Course description</label>
            <textarea rows="8" name="description" id="description" v-model="publication.description" disabled></textarea>
          </div>
        </div>
        <div class="col-12">
          <div class="input text">
            <label for="name">Who is this course for?</label>
            <input type="text" name="input_audience" id="input_audience" v-model="publication.ai_preferences.input_audience" disabled>
          </div>
        </div>
        <div class="col-12">
          <div class="input text">
            <label for="name">Are there any particular types of activities or presentation methods you want to prioritize?</label>
            <input type="text" name="input_level" id="input_level" v-model="publication.ai_preferences.input_level" disabled>
          </div>
        </div>
        <div class="col-12">
          <div class="input text">
            <label for="name">What are your learning objectives?</label>
            <textarea rows="8" name="input_extra_prompt" id="input_extra_prompt" v-model="publication.ai_preferences.input_extra_prompt" disabled></textarea>
          </div>
        </div>
        <div class="col-12">
          <label for="name" class="checkbox__group-label">Golden Source</label>
          <div v-for="topic in selectedTopics" :key="topic.uuid" class="checkbox">
            <label>
              <input type="checkbox" disabled checked>
              {{ topicByUUID(topic) }}
            </label>
          </div>
        </div>
      </div>
      <div class="app-create-new-ai-content__section-footer">
        <app-button theme="secondary" @click="$emit('previousScreen')">
          Back
        </app-button>
        <app-button theme="ai-primary"
          type="submit"
          class=""
          :disabled="disabledButton || !prerequisitesMet"
          @click="$emit('submit')">
          <svg class="element-icon--ai element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-ai"></use></svg>
          {{ disabledButton ? 'Processing...' : (isRegenerating ? 'Regenerate Outline' : 'Generate Outline') }}
        </app-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublicationAiAppFinalReviewUploadSources',
  props: {
    topics: {
      type: Array,
      default: () => ([])
    },
    publication: {
      type: Object,
      required: true
    },
    disabledButton: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedTopics: {
      type: Array,
      default: () => ([])
    },
    isRegenerating: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    prerequisitesMet () {
      return true
    },
  },
  methods: {
    topicByUUID(uuid) {
      for (const domain of this.topics) {
        const topic = domain.topics.find(topic => topic.uuid === uuid)
        if (topic)
          return topic.name
      }
      return null
    }
  }
}
</script>